import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * useSeoPageDraft(slug)
 *
 * Fetches /api/seo/page-drafts/public/by-slug and, if the admin has published
 * a hero draft for this slug, returns { heroUrl, heroAlt, heroCaption, ogUrl }.
 *
 * Fails silently (returns the empty shape) on prerender / network error — the
 * live page keeps rendering its existing static image. Zero disruption to SEO.
 */
export function useSeoPageDraft(slug) {
  const [draft, setDraft] = useState({
    heroUrl: null,
    heroAlt: "",
    heroCaption: "",
    ogUrl: null,
    loaded: false,
  });

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(
          `${API}/api/seo/page-drafts/public/by-slug?slug=${encodeURIComponent(slug)}`,
        );
        if (!r.ok) return;
        const d = await r.json();
        if (cancelled) return;
        setDraft({
          heroUrl: d.hero_image_id ? `${API}/api/ai-studio/files/${d.hero_image_id}` : null,
          heroAlt: d.hero_alt || "",
          heroCaption: d.hero_caption || "",
          ogUrl: d.og_image ? `${API}/api/ai-studio/files/${d.og_image}` : null,
          loaded: true,
        });
      } catch (_) {
        /* silent — fall back to static image */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return draft;
}
